<template>
	<WebViewLayout>
		<ArticleBodyContent
			:body-content-classes="'article-body article-body--ios wysiwyg-generated-content clearfix'"
			:body-content="blogArticle?.body ?? []"
			:key-takeaways="keyTakeaways"
		/>
		<ArticleBodyContent
			v-if="blogArticle?.footnotes"
			:body-content-classes="'article-disclaimers article-disclaimers--ios body-xs text-color-content-tertiary mt-100 pt-100 pt-200-md mt-200-md'"
			:body-content="blogArticle?.footnotes ?? []"
			:key-takeaways="keyTakeaways"
		/>
	</WebViewLayout>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { SanityArticle, SanityKeyTakeaway } from 'types/sanity/education-center';
import { useRoute, useRouter } from 'vue-router';
import ArticleBodyContent from '@components/blog/article-body-content.vue';
import { getSanityBlogArticle } from '@api/sanity/graphql/blog-education-center';
import WebViewLayout from '@views/webview/web-view-layout.vue';

const route = useRoute();
const router = useRouter();

const blogArticle = ref<SanityArticle | null>(null);
const loading = ref(true);

const keyTakeaways = computed((): Array<SanityKeyTakeaway> => {
	return blogArticle.value?.keyTakeawaysSection ?? [];
});

async function setup(): Promise<void> {
	const getArticle = await getSanityBlogArticle(route, 'article-body-content');

	if (getArticle) {
		blogArticle.value = getArticle;
	} else {
		await router.push({
			path: '/404'
		});
	}
	loading.value = false;
}
setup();
</script>
